const showAll = ({
  containerSelector = `.js-show-all`,
  itemSelector = `.js-show-all-item`,
  buttonSelector = `.js-show-all-btn`,
  hideClass = `hide`,
  scrollClass = `scroll`,
  visibleCount = 10,
  ButtonLabels = {
    SHOW: `Показать ещё`,
    HIDE: `Скрыть`,
  },
}) => {
  const containerElements = document.querySelectorAll(containerSelector);

  let isHidden = false;

  const hideItems = (items) => {
    items.forEach((item) => {
      item.classList.add(hideClass);
    });

    isHidden = true;
  };

  const showItems = (items) => {
    items.forEach((item) => {
      item.classList.remove(hideClass);
    });

    isHidden = false;
  };

  if (containerElements.length) {
    containerElements.forEach((container) => {
      const items = container.querySelectorAll(itemSelector);
      const buttonElement = container.querySelector(buttonSelector);

      // ButtonLabels.SHOW = buttonElement.textContent;

      if (items.length > visibleCount) {
        const hiddenItems = Array.from(items).filter((item, index) => index + 1 > visibleCount);

        hideItems(hiddenItems);

        buttonElement.addEventListener(`click`, (evt) => {
          evt.preventDefault();

          // if (isHidden) {
          showItems(hiddenItems);
          container.classList.add(scrollClass);
          //   buttonElement.textContent = ButtonLabels.HIDE;
          // } else {
          //   hideItems(hiddenItems);
          //   container.classList.remove(scrollClass);
          //   buttonElement.textContent = ButtonLabels.SHOW;
          // }
        });
      } else {
        buttonElement.remove();
      }
    });
  }
};

export default showAll;
